
//import * as Sentry from "@sentry/browser";
import { Component, Watch, Mixins  } from "vue-property-decorator";
import { appVersion, auth ,remoteConfig} from "@/scripts/firebase"
import { getValue,fetchAndActivate} from "firebase/remote-config"
import { ActionLinkParams} from "@/scripts/datatypes"
import {} from '@/scripts/common'
import { getAuth, onIdTokenChanged, Unsubscribe} from "firebase/auth"
import {onSnapshot, serverTimestamp } from "firebase/firestore"
//import firebase from "firebase";
import Sidebar from "@/components/Sidebar.vue";
import { localize } from 'vee-validate';
import Common from '@/mixins/common';
import ModalAlert from "@/components/ModalAlert.vue"
import { CustomClaims, Roles } from "./common-datatypes";


@Component({
  components: {
    Sidebar,
    ModalAlert
  }
})

export default class App extends Mixins(Common) {
  authObservers: (Unsubscribe | undefined)[] = []
  userDocObservers: (Unsubscribe | undefined)[] = []
  invitationObservers: (Unsubscribe | undefined)[] = []

  showNotice = true
  updateRequired = false
  isOlderVersion = false
  changedRoles = false
  latestVersion = ''
  currentVersion = appVersion
  
  setLang(lang: string){
    if(this.$i18n.messages[lang]){
      this.$store.commit('setLang', lang);
      this.$i18n.locale = lang
      auth.languageCode = lang
  
      document.documentElement.lang = lang
      localize(lang)
      return true
    }
    return false
  }

  setMeta(){
    if(! this.$route.name){
      return
    }

    let title = this.$t('serviceName.marito') as string

    if(this.$store.getters.actionLinkMode){
      if(this.$te(`actionLink.action.${this.$store.getters.actionLinkAction}`)){
        title += ' ' + this.$t(`actionLink.action.${this.$store.getters.actionLinkAction}`)
      }else if(this.$te(`actionLink.mode.${this.$store.getters.actionLinkMode}`)){
        title += ' ' + this.$t(`actionLink.mode.${this.$store.getters.actionLinkMode}`)
      }else{
        title += ' ' + this.$t('message.error') as string
      }
    }else{
      title += ' ' + this.$t(`pageTitle.${this.$route.name}`)
    }

    document.title = title
    
    const metaDescription = document.querySelector("meta[name='description']")
	
    if(! metaDescription){
      return
    }

		if(this.$route.meta && this.$route.meta.description){
      metaDescription.setAttribute('content',this.$t(`description.${this.$route.meta.description}`) as string)
      return
    }
    
    if(this.$router && this.$router.options && this.$router.options.routes){
      const routeHome = this.$router.options.routes.find((route) => {return route.path === '/' && route.meta && route.meta.description})
      if(routeHome && routeHome.meta ){
        metaDescription.setAttribute('content',this.$t(`description.${routeHome.meta.description}`) as string)
      }
    }
  }

  setDefaultLang(){
    const language = (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language
    const lang = (language || "").substr(0, 2);

    if(! this.setLang(lang)) {
      this.setLang(this.$i18n.locale)
    }

    if(this.$route.query.lang){
      this.setLang(this.$route.query.lang as string)
    }
  }

  setActionLinkParams(){
    const params = {} as ActionLinkParams
    if(this.$route.query && this.$route.query.mode){
      params.mode = this.$route.query.mode as ActionLinkParams['mode']

      if(this.$route.query.oobCode){
        params.actionCode = this.$route.query.oobCode as string
      }

      if(this.$route.query.continueUrl){
        const continueUrl = new URL(this.$route.query.continueUrl as string)
        const searchParams = new URLSearchParams(continueUrl.search)

        params.continueUrl = continueUrl.origin + continueUrl.pathname as ActionLinkParams['continueUrl']

        if(searchParams.get('action')){
          params.action = searchParams.get('action') as ActionLinkParams['action']
        }

        if(searchParams.get('uid')){
          params.uid = searchParams.get('uid') as string
        }
        
        if(searchParams.get('token')){
          params.token = searchParams.get('token') as string
        }
      }

      if(! params.action && this.$route.query.action){
        params.action = this.$route.query.action as ActionLinkParams['action']
      }

      if(! params.uid && this.$route.query.uid){
        params.uid = this.$route.query.uid as string
      }

      if(! params.token && this.$route.query.token){
        params.token = this.$route.query.token as string
      }

      //console.log(params)

    }
    this.$store.commit('setActionLink',params)
    //Sentry.captureMessage(JSON.stringify(params))
    //Sentry.captureMessage(JSON.stringify(this.$route.query))
  }

  reload(ok: boolean){
    if(ok){
      const time = Date.now()
      const href = window.location.origin + window.location.pathname + '?update=' + time
      window.location.href = href
    }
  }

  isOnline = window.navigator.onLine

  async created() {
    let timer: number
    console.trace('created')

    this.setDefaultLang()

    this.setActionLinkParams()

    window.addEventListener('online', (event) => {
      this.isOnline = true
    })

    window.addEventListener('offline', (event) => {
      this.isOnline = false
    })

    this.$watch('signedUp',(signedUp: boolean) => {
      window.clearTimeout(timer)
      if(signedUp && this.autoSignOutTimer){
        window.clearTimeout(this.autoSignOutTimer)
      }
      
      if(signedUp && this.$route.name !== 'introduction'){
        timer = window.setTimeout(() => {
          this.$router.push({ name: 'introduction'})
        },1000);
      }
    })

    this.authObservers.push(onIdTokenChanged(auth, async user => {
      console.log("idTokenChanged:")
      if(user && user.uid){
        try{
          this.$store.commit("setUser",user)
          this.$store.commit("setLoading",true)

          const idToken = await user.getIdTokenResult()
          if(idToken.claims && typeof idToken.claims.schools === 'object'){
            this.$store.commit("setCustomClaims", idToken.claims)

          }else{
            console.log("idTokenChanged: null");
            this.$unsubscriber(this.userDocObservers)
            this.userDocObservers = []
            this.$store.commit("setCustomClaims", null)
            this.$store.commit("setSchool",null);
          }
        }catch(error){
          console.error("getIdTokenResult", error);
        }finally{
          this.$store.commit("setLoading",false);
        }
      }else{
        console.log("idTokenChanged: null");
        this.$unsubscriber(this.userDocObservers)
        this.userDocObservers = []
        this.$store.commit("setHasInvitation",false)
        this.$store.commit("setUser",null)
        this.$store.commit("setCustomClaims", null)
        this.$store.commit("setSchool",null)
        this.$store.commit("setUserPrivateProfile", null)
        this.$store.commit("setUserPublicProfile", null)
        this.$store.commit("setUserRelationship", null)
      }
    },() => {
      console.log('xyz')
    }))

    await this.checkVersion()
  }

  mounted(){
    console.trace('mounted')
  }

  get noSchool(): boolean {
    return this.$store.getters.noSchool
  }

  get invited(): boolean {
    return this.$store.getters.invited
  }

  get hasInvitation(): boolean {
    return this.$store.state.hasInvitation
  }

  get signedUp(): boolean {
    return this.$store.getters.signedUp
  }

  get signIn(): boolean {
    return !! this.$store.getters.uid
  }

  get schools(): CustomClaims['schools'] {
    return this.$store.getters.schools || {}
  }

  get roles(): Roles {
    return this.$store.getters.roles || []
  }

  get claimsRoles(){
    return this.schools[this.schoolId] ? this.schools[this.schoolId].roles : []
  }

  @Watch('roles')
  async changeRoles(roles: Roles){
    if(roles.length > 0 && this.claimsRoles.length > 0){
      if(this.claimsRoles.toString() !== roles.toString()){
        await getAuth().currentUser?.getIdToken(true)
        this.changedRoles = true
        this.updateRequired = true
      }
    }
  }


  @Watch('invited')
  changeInvited(invited: boolean){
    if(invited && this.$route.name !== 'enterSchool' && this.$route.name == 'signInWithPhone'){
      this.$router.push({ name: 'enterSchool'})
    }
  }

  autoSignOutTimer = 0
  
  @Watch('signIn')
  changeSignIn(signIn: boolean){
    if(signIn){
      this.autoSignOutTimer = window.setTimeout(() => {
        auth.signOut()
      },10000)
      this.observeInvitation()
    }else{
      this.$unsubscriber(this.invitationObservers)
      this.invitationObservers = []
    }
  }

  @Watch('signedIn')
  changeSignedIn(signedIn: boolean){
    if(signedIn){
      window.clearTimeout(this.autoSignOutTimer)
    }
    //signed , go to dashboard or schedule
    //this.$router.push({name: 'dashboard'})

    if(signedIn && this.$route.name == 'signInWithPhone'){
      //TODO: go to dashboard finally.
      console.log(this.numSchools)
      if(this.numSchools == 0){
        this.$router.push({ name: 'account'})
      }else{
        this.$router.push({ name: 'dashboard'})//schedule
      }
    }
  }

  get numSchools(): number {
    return this.$store.getters.numSchools
  }
  
  get signedIn(): boolean {
    return !! (this.$store.getters.schoolId && this.$store.getters.uid && this.$store.state.school && this.$store.state.userPrivateProfile && this.$store.state.userPublicProfile && this.$store.state.userRelationship)
  }

  get authorized(): boolean {
    if(this.$store.getters.disabled === true || ! this.$route.meta || ! this.$route.meta.accessLevel || ! this.$store.getters.roles){
      return false
    }

    if(this.$store.getters.roles.some((role: string) =>{
      return this.$route.meta && this.$route.meta.accessLevel[role]
    })){
      return true
    }
    return false
  }

  get isPublic(): boolean{
    try{
      return !! this.$route.matched[0].components.public
    }catch(error){
      return false
    }
  }

  get is404(){
    return (this.$route.name === 'notFound') ? true : false
  }

  

  @Watch('routePath')
  changeRoutePath(){
    this.setMeta()
  }

  @Watch('userLang')
  changeUserLang(userLang: string){
    this.setLang(userLang)
    this.setMeta()
  }

  @Watch('lang')
  changeLang(){
    this.setMeta()
  }

  @Watch('userId')
  async changeUserId(userId: string){
    try{
      this.$unsubscriber(this.userDocObservers)
      this.userDocObservers = []

      this.$store.commit("setSchool",null)
      this.$store.commit("setUserPrivateProfile", null)
      this.$store.commit("setUserPublicProfile", null)
      this.$store.commit("setUserRelationship", null)

      if(! userId){
        return
      }

      this.setObservers()

      const userDocRef = this.$getUserPrivateProfileDocRef()
      const data = {
        lastSignInTime: serverTimestamp()
      }

      await this.$updateDoc(userDocRef,data)
    }catch(error){
      console.log(error)
    }
  }

  observeInvitation(){
    this.invitationObservers.push(onSnapshot(this.$getInvitationTokenQuery(this.uid,'uid'), (snapshot) => {
      if(snapshot.empty){
        this.$store.commit("setHasInvitation",false)
      }else{
        this.$store.commit("setHasInvitation",true)
      }
    }))
  }

  setObservers(){
    const schoolPublicProfileDocRef = this.$getSchoolPublicProfileDocRef()

    this.userDocObservers.push(onSnapshot(schoolPublicProfileDocRef, (snapshot) => {
      if(snapshot.exists()){
        this.$store.commit("setSchool", snapshot.data())
      }else{
        this.$store.commit("setSchool", null)
      }
    },() => {
      this.$store.commit("setSchool", null)
    }))

    const userPublicProfileDocRef = this.$getUserPublicProfileDocRef()
    
    this.userDocObservers.push(onSnapshot(userPublicProfileDocRef,(snapshot) => {
      if(snapshot.exists()){
        this.$store.commit("setUserPublicProfile", snapshot.data());
      }else{
       this.$store.commit("setUserPublicProfile", null)
      }
    },() => {
      this.$store.commit("setUserPublicProfile", null)
    }))

    const userPrivateProfileDocRef = this.$getUserPrivateProfileDocRef()

    this.userDocObservers.push(onSnapshot(userPrivateProfileDocRef,(snapshot) => {
      if(snapshot.exists()){
        this.$store.commit("setUserPrivateProfile", snapshot.data())
      }else{
        this.$store.commit("setUserPrivateProfile", null)
      }
    },() => {
      this.$store.commit("setUserPrivateProfile", null)
    }))

    const userRelationshipDocRef = this.$getUserRelationshipDocRef()

    this.userDocObservers.push(onSnapshot(userRelationshipDocRef,(snapshot) => {
      if(snapshot.exists()){
        this.$store.commit("setUserRelationship", snapshot.data())
      }else{
        this.$store.commit("setUserRelationship", null)
      }
    },() => {
      this.$store.commit("setUserRelationship", null)
    }))
  }
  
  get routePath(): string {
    return this.$route.path
  }

  get userLang(): string {
    return this.$store.getters.userLang
  }

  get lang(): string {
    return this.$store.getters.lang
  }

  get schoolId(): string {
    return this.$store.getters.schoolId
  }

  get userId(): string {
    return this.$store.getters.userId || ''
  }

  get uid(): string {
    return this.$store.getters.uid || ''
  }

  async checkVersion(){
    try{
      await fetchAndActivate(remoteConfig)
      this.latestVersion = getValue(remoteConfig, 'version').asString()

      const currentVersionNum = Number(this.currentVersion.replaceAll('.','').replace(/[\D]/,''))
      const latestVersionNum = Number(this.latestVersion.replaceAll('.','').replace(/[\D]/,''))

      if(currentVersionNum > 0 && latestVersionNum > 0 && currentVersionNum < latestVersionNum){
        this.updateRequired = true
        this.isOlderVersion = true
      }
    }catch(error){
      console.error(error)
    }
  }

  destroyed() {
    this.$unsubscriber(this.authObservers)
    this.$unsubscriber(this.invitationObservers)
    this.$unsubscriber(this.userDocObservers)
    console.trace('destroyed');
  }
}

